import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
} from "react-icons/fa";
import { BsMessenger } from "react-icons/bs";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import Title from "../shared/Title";

const Footer = () => {
  return (
    <footer className="bg-secondary px-4 py-12 text-sm text-white md:px-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-4">
        {/* Get In Touch */}
        <div>
          <Title title="Get In Touch" className="mb-4 hidden xl:block" />
          <h3 className="text-primary mb-4 text-2xl font-bold xl:hidden">
            Get In Touch
          </h3>
          <p className="mb-2 flex items-start gap-2 text-lg">
            <FaMapMarkerAlt className="text-primary mt-1" />
            <span>
              Tanta, El bahr Street - in front of Tanta Hospital <br />
              above Almokhtabar Lab
            </span>
          </p>
          <a
            href="mailto:research@biostat.com"
            className="mb-2 flex items-center gap-2 text-lg hover:underline"
          >
            <FaEnvelope className="text-primary" />
            research@biostat.com
          </a>

          <a
            href="tel:+201289087489"
            className="flex items-center gap-2 text-lg hover:underline"
          >
            <FaPhoneAlt className="text-primary" />
            +2010 701 01097
          </a>
          {/* Follow Us */}
          <div className="flex space-x-4 px-1 pt-6 text-2xl">
            <a
              href="https://www.facebook.com/BioStatHouse"
              aria-label="Visit our Facebook page"
              className="transform transition-transform duration-300 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://wa.me/201070101097"
              aria-label="Chat with us on WhatsApp"
              className="transform transition-transform duration-300 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.linkedin.com/company/biostathouse"
              aria-label="Visit our LinkedIn page"
              className="transform transition-transform duration-300 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <Title title="Quick Links" className="mb-4 hidden xl:block" />
          <h3 className="text-primary mb-4 text-2xl font-bold xl:hidden">
            Quick Links
          </h3>
          <ul className="space-y-2 text-lg">
            <li>
              <Link to="/" className="flex items-center gap-2 hover:underline">
                <MdOutlineKeyboardArrowRight /> Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> Services
              </Link>
            </li>
            <li>
              <Link
                to="/workshops"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> Workshops
              </Link>
            </li>
            <li>
              <Link
                to="/blogs"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> Blogs
              </Link>
            </li>
          </ul>
        </div>

        {/* Popular Services */}
        <div>
          <Title title="Popular Services" className="mb-4 hidden xl:block" />
          <h3 className="text-primary mb-4 text-2xl font-bold xl:hidden">
            Popular Services
          </h3>
          <ul className="space-y-2 text-lg">
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Workshops
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Results
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Sample Size
              </p>
            </li>
            <li>
              <Link
                to="/services"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> All Services
              </Link>
            </li>
          </ul>
        </div>

        {/* Best Workshops */}
        <div>
          <Title title="Best Workshops" className="mb-4 hidden xl:block" />
          <h3 className="text-primary mb-4 text-2xl font-bold xl:hidden">
            Best Workshops
          </h3>
          <ul className="space-y-2 text-lg">
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Biostatics
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Endnote
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2">
                <MdOutlineKeyboardArrowRight /> Sample Size Calculations
              </p>
            </li>
            <li>
              <Link
                to="/workshops"
                className="flex items-center gap-2 hover:underline"
              >
                <MdOutlineKeyboardArrowRight /> All Workshops
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
